import React from "react";
import { Route } from "react-router-dom";
import { menuConfig } from "../configs/MenuConfig";
import * as CustomerPages from "../pages/customer";
import CustomerPanel from "../pages/customer/CustomerPanel";

import CustomerProfileEdit from "../pages/customer/CustomerProfileEdit";
import AdminCustomerProfileView from "../pages/customer/AdminCustomerProfileView";
import AdminCustomerProfileEdit from "../pages/customer/AdminCustomerProfileEdit";
import PanelLayout from "../layouts/PanelLayout";

import ProtectedRoute from "../components/ProtectedRoute";


function renderRoutes(items = []) {
    return items.map(({link, component, submenu}) => {
    if (link === '/password-setting/') {
      return null;
    }
        const Page = component ? CustomerPages[component] : undefined;

        return (
            <Route key={link} path={link} element={Page ? <Page/> : undefined}>
                {submenu && renderRoutes(submenu)}
            </Route>
        );
    });
}
export default function CustomerRoutes() {
    const routes = menuConfig.customer.items;
    return (
        <Route path="/customer-panel" element={<ProtectedRoute allowedRoles={["customer","admin"]}><PanelLayout user ='customer'/></ProtectedRoute>}>
          <Route path="customer-profile-edit" element={<CustomerProfileEdit />} />
          <Route path="customer-profiles/:id/view" element={<AdminCustomerProfileView />} />
          <Route path="customer-profiles/:id/edit" element={<AdminCustomerProfileEdit />} />
          <Route index element={<CustomerPanel />} />
            {renderRoutes(routes)}
        </Route>
    );
}